import { render, staticRenderFns } from "./CheckoutSectionInstance.vue?vue&type=template&id=807b82fc"
import script from "./CheckoutSectionInstance.vue?vue&type=script&lang=js"
export * from "./CheckoutSectionInstance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports